import { tracker } from '../../core/defaults';

export const TRACK_ASK_QUESTION = 'Ask us a question CTA';
export const TRACK_HELP_CENTRE = 'Help centre CTA';

/**
 * Tracks an event and closes the menu
 * @param {string} eventName - the event to track
 */
export const trackHelpMenuEvent = (eventName: string) => {
  tracker.track(eventName);
};
